import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ImpersonationBroker, asApiError } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { KEYWORD_PINS_TYPE, type KeywordPinView, type WritePinBody } from '../pins/serverTypes';
import { queryKeys } from './queryKeys';

export function useCreateKeywordPin(): UseMutationResult<KeywordPinView, Error, WritePinBody> {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation<KeywordPinView, Error, WritePinBody>({
		mutationFn: async body => {
			const result = await userSession.webServiceHelper.callWebServiceAsync<KeywordPinView>(
				ImpersonationBroker.composeApiUrl({ urlPath: `user/coffee/customizations/${KEYWORD_PINS_TYPE}` }),
				'POST',
				body
			);
			if (!result.success) {
				throw asApiError(result);
			}
			return result.value;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.focusedView.keywordPins() });
		},
		onError: () => {
			toast.error('Failed to save keyword pin');
		},
	});
}
